import React, { useEffect } from "react";
import PageWrapper from "../../components/Page/PageWrapper";
import MonitoringQueueActions from "./components/MonitoringQueueActions/MonitoringQueueActions";
import MonitoringQueueTable from "./components/MonitoringQueueTable/MonitoringQueueTable";
import { useDispatch } from "react-redux";
import { clearMonitoringQueue } from "../../redux/features/monitoringQueue/monitoringQueueSlice";

const MonitoringQueue = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearMonitoringQueue());
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PageWrapper>
      <MonitoringQueueActions />
      <MonitoringQueueTable />
    </PageWrapper>
  );
};

export default MonitoringQueue;
